import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import VueInputMask from 'vue-inputmask-ng'
import './validation'
import i18n from './i18n'


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueInputMask)

let queryLang = new URL(location.href).searchParams.get('lang');
queryLang = queryLang ? queryLang.toLowerCase() : 'tr'

let appName = new URL(location.href).searchParams.get('app')
appName = !!appName && (appName.toLowerCase() == 'justsnap') ? 'justsnap' : 'cekkazan'
Vue.prototype.$appName = appName;
window.axios = axios

const getBaseUrl = () => {
  return 'https://api.cekkazanapp.com/api'
}

window.axiosInstance = axios.create({
  baseURL: getBaseUrl(),
  // headers: {
  //   key: 'value'
  // }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

i18n.locale = queryLang
console.log('LANGUAGE: ', i18n.locale)